/* ============================================================
   MUSE DISC — main.js
   Init order: Lenis → GSAP → ScrollTrigger → global helpers
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initGSAP();   // GSAP must register before Lenis connects to it
  initLenis();
  initLoader();
  initFadeIns();
});

/* --- GSAP + ScrollTrigger ----------------------------------- */
function initGSAP() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);
  // Prevent spurious ScrollTrigger.refresh() on mobile address-bar resize
  ScrollTrigger.config({ ignoreMobileResize: true });
  window.gsap = gsap;
  window.ScrollTrigger = ScrollTrigger;
}

/* --- Lenis -------------------------------------------------- */
function initLenis() {
  if (typeof Lenis === 'undefined') return;

  const lenis = new Lenis({
    duration: 1.2,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    smoothWheel: true,
  });

  if (typeof gsap !== 'undefined') {
    // Let GSAP's ticker drive Lenis — single RAF loop, no duplication
    gsap.ticker.add(time => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);

    // Pass ScrollTrigger.update by reference so Lenis calls it directly
    // without creating a new closure on every tick
    if (typeof ScrollTrigger !== 'undefined') {
      lenis.on('scroll', ScrollTrigger.update);
    }
  } else {
    // No GSAP — own RAF loop
    (function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    })(performance.now());
  }

  window.lenis = lenis;
}

/* --- Loader ------------------------------------------------- */
function initLoader() {
  const loader = document.getElementById('loader');
  if (!loader) return;

  const words = loader.querySelectorAll('.logo__word');

  if (!words.length || typeof gsap === 'undefined') {
    setTimeout(() => {
      loader.remove();
      document.body.classList.remove('no-scroll');
    }, 2200);
    return;
  }

  document.body.classList.add('no-scroll');

  gsap.set(words, {
    clipPath: 'inset(0 100% 0 0)',
    filter: 'blur(8px)',
    x: -8,
  });

  const tl = gsap.timeline({
    onComplete: () => {
      loader.style.pointerEvents = 'none';
      document.body.classList.remove('no-scroll');
    },
  });

  tl
    .to(words[0], {
      clipPath: 'inset(0 0% 0 0)',
      filter: 'blur(0px)',
      x: 0,
      duration: 0.55,
      ease: 'power4.out',
    })
    .to(words[1], {
      clipPath: 'inset(0 0% 0 0)',
      filter: 'blur(0px)',
      x: 0,
      duration: 0.55,
      ease: 'power4.out',
    }, '-=0.35')
    .to({}, { duration: 0.55 })
    .to(words, {
      y: -24,
      opacity: 0,
      duration: 0.4,
      stagger: 0.07,
      ease: 'power2.in',
    })
    .to(loader, {
      opacity: 0,
      duration: 0.3,
      ease: 'none',
      onComplete: () => { loader.remove(); },
    }, '-=0.15');
}

/* --- Global fade-ins (ScrollTrigger) ----------------------- */
function initFadeIns() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.utils.toArray('.js-fade').forEach(el => {
    gsap.fromTo(el,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true,
        },
      }
    );
  });
}
